<template>
  <v-container
    fluid
    class="d-flex flex-column align-center justify-center"
    style="height: 80vh;"
  >
    <v-card class="pa-8 text-center" elevation="3" max-width="450">
      <v-icon size="64" color="primary" class="mb-4">
        mdi-tools
      </v-icon>

      <h2 class="font-weight-bold mb-2">
        Estamos trabajando en esta sección
      </h2>

      <p class="grey--text text--darken-1 mb-6">
        Muy pronto podrás consultar los detalles de este producto.
      </p>

      <v-btn
        color="primary"
        large
        @click="$router.push({ name: 'portafolio' })"
      >
        <v-icon left>mdi-arrow-left</v-icon>
        Volver a Productos
      </v-btn>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'UnderConstruction'
}
</script>

<style scoped>
</style>
